module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("He lifts his fingers toward the skies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where holy brightness breaks in flame;")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Radiance reflected in his eyes,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And on his lips a whispered name.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break",
    staticStyle: {
      "margin-left": "3em"
    }
  }, [_vm._v("‘How To Die’, Siegfried Sassoon")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e4dfa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface003.vue
// module id = 75
// module chunks = 0